if (!customElements.get('embroidery-modal')) {
  class Embroidery extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
      this.handleATCIntercept = this.handleATCIntercept.bind(this);
      
    }

    connectedCallback() {
      //UI Elements
      this.optionsEl = this.querySelector('[data-options]');
      this.formEl = this.querySelector('[data-embroidery-form]');
      this.optionGroups = {
        placement: this.querySelector('[data-options-group="placement"]'),
        text: this.querySelector('[data-options-group="text"]'),
        icons: this.querySelector('[data-options-group="icons"]')
      };
      this.textGroups = {
        toggle: this.querySelector('[data-text-group="toggle"]'),
        text: this.querySelector('[data-text-group="text"]')
      };
      this.iconGroups = {
        toggle: this.querySelector('[data-icon-group="toggle"]'),
        icon: this.querySelector('[data-icon-group="icon"]'),
        custom: this.querySelector('[data-icon-group="custom"]'),
        placement: this.querySelector('[data-icon-group="placement"]')
      };
      //Embroidery Elements
      this.addSpan = document.querySelector('[data-add-span]');
      this.lines = Array.from(this.querySelectorAll('[data-text-line]'));
      this.totalEl = this.querySelector('[data-line-total]');
      this.positionEl = this.querySelector('[data-current-position]');
      this.fontNameEl = this.querySelector('[data-current-font]');
      this.colorNameEl = this.querySelector('[data-current-color]');
      this.logoPriceEl = this.querySelectorAll('[data-current-logo-price]');
      this.logoNameEl = this.querySelectorAll('[data-current-logo]');
      this.currentCustomEl = this.querySelector('[data-current-custom]');
      this.linePrice = Number(this.dataset.linePrice);
      this.lineSize = this.dataset.lineSize;
      this.maxLines = Number(this.dataset.maxLines);
      this.ctaButton = this.querySelector('[data-embroidery-total]')?.closest('button');
      this.embroideryTotalEl = this.querySelector('[data-embroidery-total]');
      this.embroideryId = this.dataset.embroideryId || null;
      //Custom logo
      this.customLogoUploader = this.querySelector('[data-custom-logo-uploader]');
      this.customLogoInput = this.querySelector('[data-custom-logo-input]');
      this.customLogoEmpty = this.querySelector('[data-custom-logo-empty]');
      this.customLogoPreview = this.querySelector('[data-custom-logo-preview]');
      this.customLogoImage = this.querySelector('[data-custom-logo-image]');
      this.customLogoLoader = this.querySelector('[data-custom-logo-loader]');
      this.customLogoError = this.querySelector('[data-custom-logo-error]');
      this.customLogoNotes = this.querySelector('[data-custom-logo-notes]');
      this.customLogoNotesContainer = this.querySelector('[data-custom-logo-notes-container]');
      this.customLogoAuthCheckbox = this.querySelector('[data-custom-logo-auth]');
      this.customLogoAuthError = this.querySelector('[data-custom-logo-auth-error]');
      this.customLogoPrice = Number(this.dataset.customLogoPrice || 0);
      this.customLogoDigitizationPrice = Number(this.dataset.customLogoDigitizationPrice || 0);
      this.customLogoMaterialId = this.dataset.customLogoMaterialId || null;
      this.customLogoDigitizationId = this.dataset.digitizationId || null;
      this.customLogoDigitizationMaterialId = this.dataset.customLogoDigitizationMaterialId || null;
      this.presetIconMaterialId = this.dataset.presetIconMaterialId || null;
      //Ghost Image
      this.logoPositionGroup = this.querySelector('[data-logo-position-group]');
      this.logoPositionEl = this.querySelector('[data-current-logo-position]');
      this.logoPosition = { value: 'Above' };
      this.ghostCopy = this.querySelector('[data-ghost-copy]');
      //Preview tabs
      this.previewTabs = this.querySelector('[data-preview-tabs]');
      this.ghostImageInner = this.querySelector('[data-ghost-image-inner]');
      this.fullImageEl = this.querySelector('[data-full-image]');
      this.sleeveImageEl = this.querySelector('[data-sleeve-image]');
      this.previewView = 'full';
      //Form Controls
      this.externalATC = document.querySelector('coco-shuffle [data-action="add-to-cart"]');
      this.externalQTY = document.querySelector('select[data-quantity]');
      this.productForm = this.externalATC?.closest('form');
      this.confirmEmbroideryEl = document.querySelector('[data-confirm-embroidery]');
      this.confirmCheckbox = this.confirmEmbroideryEl?.querySelector('input[type="checkbox"]');
      this.initActiveState();
      this.initEvents();
      this.updateAddButtons();
      this.updateLineTotal();
      this.updateEmbroideryState();
      this.updateLogoConstraints();
      this.updateGhost();
    }

    disconnectedCallback() {
      if (this.productForm) {
        this.productForm.removeEventListener('submit', this.handleATCIntercept);
      }
      if (this.confirmEmbroideryEl) this.confirmEmbroideryEl.classList.add('hidden');
      if (this.confirmCheckbox) this.confirmCheckbox.checked = false;
      if (this.externalATC) {
        this.externalATC.classList.remove('has-embroidery', 'emb-disabled');
      }
      if (this.externalQTY) this.externalQTY.classList.remove('hidden');
      if (this.addSpan) this.addSpan.textContent = 'Add Embroidery';
    }

    initEvents() {
      if (this.confirmCheckbox) {
        this.confirmCheckbox.addEventListener('change', () => {
          if (!this.externalATC) return;
          if (this.confirmCheckbox.checked) {
            this.externalATC.classList.remove('emb-disabled');
            this.externalATC.classList.add('has-embroidery');
          } else {
            this.externalATC.classList.add('emb-disabled');
            this.externalATC.classList.remove('has-embroidery');
          }
        });
      }
      if (this.customLogoAuthCheckbox) {
        this.customLogoAuthCheckbox.addEventListener('change', () => {
          if (this.customLogoAuthCheckbox.checked) {
            this.customLogoAuthError?.classList.add('hidden');
          }
          this.updateEmbroideryState();
        });
      }
      const triggerButton = this.querySelector('[data-action="trigger-custom-logo"]');
      if (triggerButton && this.customLogoInput) {
        triggerButton.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          this.customLogoInput.click();
        });
      }
      if (this.customLogoUploader) {
        this.customLogoUploader.addEventListener('dragover', e => e.preventDefault());
        this.customLogoUploader.addEventListener('drop', e => {
          e.preventDefault();
          const file = e.dataTransfer.files[0];
          if (file) this.handleCustomLogoπFile(file);
        });
      }
      if (this.customLogoInput) {
        this.customLogoInput.addEventListener('change', e => {
          const file = e.target.files[0];
          if (file) this.handleCustomLogoFile(file);
        });
      }
      this.addEventListener('input', e => {
        if (!e.target.matches('[data-text-line] input')) return;
        e.target.value = e.target.value.replace(/[\p{Extended_Pictographic}]/gu, '');
        const line = e.target.closest('[data-text-line]');
        const counter = line?.querySelector('[data-line-count]');
        if (counter) {
          counter.textContent = `${e.target.value.length}/${e.target.maxLength}`;
        }
        this.updateEmbroideryState();
      });
      if (this.previewTabs) {
        this.previewTabs.addEventListener('click', e => {
          const tab = e.target.closest('[data-preview-tab]');
          if (!tab) return;
          this.updatePreviewView(tab.dataset.previewTab);
        });
      }
      if (this.productForm) this.productForm.addEventListener('submit', this.handleATCIntercept);
      this.addEventListener('click', this.handleClick);
    }

    async handleATCIntercept(e) {
      if (!this.externalATC.classList.contains('has-embroidery')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const cocoShuffle = document.querySelector('coco-shuffle');
      if (cocoShuffle && !cocoShuffle.currentVariant) {
        cocoShuffle.classList.add('selection-needed');
        return;
      }

      const variantId = this.productForm.querySelector('[name="id"]')?.value;
      const qty = 1
      if (!variantId) return;
      const hasCustomLogo = this.logo?.type === `custom_logo`;
      const hasCustomerLogo = this.logo?.type === `customer_logo`;
      const logoId = hasCustomLogo ? this.logo.id : null;
      const bundleId = crypto.randomUUID();
      const notes = hasCustomLogo ? this.customLogoNotes?.value?.trim() : null;
      const items = [];
      if (hasCustomLogo) {
        items.push({
          id: Number(this.customLogoDigitizationId),
          quantity: qty,
          properties: {
            _embroidery_bundle_id: bundleId,
            _embroidery_identifier: logoId,
            _embroidery_logo_url: this.logo.url,
            _embroidery_material_id: this.customLogoDigitizationMaterialId || this.customLogoMaterialId,
            _embroidery_bundle_component: `digitization`,
            _LPROP: `Final Sale`,
            ...(notes && { Notes: notes }),
          }
        });
      }
      items.push({
        id: Number(this.embroideryId),
        quantity: qty,
        properties: {
          ...this.buildEmbroideryProperties(bundleId, this.logo),
          _embroidery_bundle_component: `embroidery`,
          _LPROP: `Final Sale`,
        }
      });
      items.push({
        id: Number(variantId),
        quantity: qty,
        properties: {
          _embroidery_bundle_id: bundleId,
          _embroidery_bundle_component: `parent`,
          _LPROP: `Final Sale`,
        }
      });
      const miniCart = document.querySelector(`mini-cart`);
      if (miniCart) {
        await miniCart.bulkAddToCart(items).then(res => {
          if (!res) return;
          if (notes) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { [`Custom Logo Note: ${bundleId}`]: notes } })
            });
          }
          miniCart.updateCartHtml(res);
          miniCart.checkUbeInventory();
          miniCart.open();
        });
      }
    }

    initActiveState() {
      const activePosition = this.querySelector(`[data-action="choose-position"]:checked`);
      if (activePosition) {
        this.position = {
          handle: activePosition.dataset.handle,
          value: activePosition.dataset.value,
          horizontal: activePosition.dataset.horizontal,
          vertical: activePosition.dataset.vertical
        };
        this.positionEl.textContent = activePosition.dataset.value.toLowerCase();
      }
      const activeFont = this.querySelector(`[data-action="change-font"].active`);
      if (activeFont) {
        this.font = {
          name: activeFont.dataset.fontName,
          family: activeFont.dataset.fontFamily,
          material: activeFont.dataset.fontMaterial,
          size: activeFont.dataset.fontSize
        };
        this.fontNameEl.textContent = activeFont.dataset.fontName;
      }
      const activeColor = this.querySelector(`[data-action="change-color"].active`);
      if (activeColor) {
        this.color = {
          name: activeColor.dataset.colorName,
          material: activeColor.dataset.colorMaterial,
          value: activeColor.querySelector('div')?.style.backgroundColor || ''
        };
        this.colorNameEl.textContent = activeColor.dataset.colorName;
      }
      const activeLogo = this.querySelector(`[data-action="add-logo"].active`);
      if (activeLogo) {
        const price = Number(activeLogo.dataset.logoPrice || 0);
        this.logo = {
          id: activeLogo.dataset.logoId,
          type: activeLogo.dataset.logoCustomer ? `customer_logo` : `preset_logo`,
          name: activeLogo.dataset.logoName,
          materialId: activeLogo.dataset.logoMaterialId,
          price,
          url: activeLogo.dataset.logoUrl
        };
        this.logoNameEl.textContent = price
          ? `(+$${price.toFixed(2).replace(/\.00$/, '')})`
          : '';
      } else {
        this.logo = {
          id: null,
          name: null,
          type: null,
          materialId: null,
          price: 0,
          url: null,
        };
      }
      const activeLogoPos = this.querySelector(`[data-action="choose-logo-position"].active`);
      if (activeLogoPos) {
        this.logoPosition = { value: activeLogoPos.dataset.value };
        this.logoPositionEl.textContent = activeLogoPos.dataset.value;
      }
    }

    buildEmbroideryProperties(bundleId, logoConfig = {}) {
      const props = {};
      const visibleLines = this.lines
        .filter(l => !l.classList.contains('!hidden'))
        .map(l => l.querySelector('input')?.value.trim())
        .filter(Boolean);
      const hasLogo = this.hasLogo();
      const lineCount = visibleLines.length + (hasLogo ? 1 : 0);
      
      props['_embroidery_bundle_id'] = bundleId;
      props['_embroidery_type'] = this.dataset.embroideryType;
      props['_embroidery_lines'] = String(lineCount);
      if (hasLogo && visibleLines.length > 0) {
        if (this.logoPosition?.value === 'Above') {
          props['_embroidery_location'] = `${this.position?.value} BELOW LOGO`;
        } else if (this.logoPosition?.value === 'Below') {
          props['_embroidery_location'] = `${this.position?.value} ABOVE LOGO`;
        }
      } else {
        props['_embroidery_location'] = this.position?.value;
      }
      if (visibleLines.length) {
        props['Text'] = visibleLines.join(' / ');
        props['Text Color'] = this.color?.name;
        props['Text Font'] = this.font?.name;
      }
      props['Placement'] = this.position?.value;
      if (hasLogo) {
        if (logoConfig.type === 'custom_logo') {
          props['Logo'] = 'Custom';
        } else if (logoConfig.name) {
          props['Logo'] = logoConfig.name;
        }
      }
      const textLineCount = visibleLines.length;
      const textMaterialId = this.getAttribute(`data-line-material-${textLineCount}`);
      let index = 1;
      const pushTextLine = (text, lineIndex) => {
        props[`_embroidery_line_${index}_type`] = 'line_embroidery';
        props[`_embroidery_line_${index}_material_id`] = textMaterialId;
        props[`_embroidery_line_${index}_content`] = text;
        props[`_embroidery_line_${index}_price`] = this.getAttribute(`data-line-${lineIndex + 1}-price`);
        props[`_embroidery_line_${index}_size`] = this.dataset.lineSize;
        props[`_embroidery_line_${index}_color`] = this.color?.material;
        props[`_embroidery_line_${index}_font`] = this.font?.material;
        index++;
      };
      const pushLogoLine = () => {
        props[`_embroidery_line_${index}_type`] = logoConfig.type;
        props[`_embroidery_line_${index}_material_id`] = logoConfig.materialId;
        props[`_embroidery_line_${index}_content`] = logoConfig.id;
        props[`_embroidery_line_${index}_price`] = String(logoConfig?.price || 0);
        props[`_embroidery_line_${index}_size`] = '';
        props[`_embroidery_line_${index}_color`] = '';
        props[`_embroidery_line_${index}_font`] = '';
        index++;
      };
      if (hasLogo && this.logoPosition?.value === 'Above') pushLogoLine();
      visibleLines.forEach(pushTextLine);
      if (hasLogo && this.logoPosition?.value === 'Below') pushLogoLine();
      return props;
    }

    getMaxLines() {
      let maxLines = this.lines.length;
      if (this.hasLogo()) { maxLines = this.maxLines - 1; }
      return maxLines;
    }
    getRemainingAvailableTextLines() {
      const maxLines = this.getMaxLines();
      const currentlyVisibleCount = this.lines.filter(l => !l.classList.contains('!hidden')).length;
      const remainingAvailableLines = maxLines - currentlyVisibleCount;
      return {maxLines, currentlyVisibleCount, remainingAvailableLines};
    }

    hasLogo() {
      return !!(this.logo && (this.logo.price > 0 || this.logo.url));
    }

    formatMoney(amount) {
      return `$${Number(amount).toFixed(2).replace(/\.00$/, '')}`;
    }

    handleClick(e) {
      const button = e.target.closest('[data-action]');
      if (!button) return;
      switch (button.dataset.action) {
        case 'text-first': {
          this.optionsEl.classList.add('hidden');
          this.formEl.classList.remove('hidden');
          this.optionGroups.placement.classList.remove('hidden');
          this.optionGroups.text.classList.remove('hidden');
          this.optionGroups.icons.classList.remove('hidden');
          this.textGroups.toggle.classList.add('hidden');
          this.textGroups.text.classList.remove('hidden');
          this.iconGroups.toggle.classList.remove('hidden');
          this.iconGroups.icon.classList.add('hidden');
          this.iconGroups.custom.classList.add('hidden');
          this.updateIconPlacementVisibility();
          break;
        }
        case 'icon-first': {
          this.optionsEl.classList.add('hidden');
          this.formEl.classList.remove('hidden');
          this.formEl.classList.add('icon-first');
          this.optionGroups.placement.classList.remove('hidden');
          this.optionGroups.text.classList.remove('hidden');
          this.optionGroups.icons.classList.remove('hidden');
          this.textGroups.toggle.classList.remove('hidden');
          this.textGroups.text.classList.add('hidden');
          this.iconGroups.toggle.classList.add('hidden');
          this.iconGroups.icon.classList.remove('hidden');
          this.iconGroups.custom.classList.add('hidden');
          this.iconGroups.placement.classList.remove('hidden');
          this.updateIconPlacementVisibility();
          break;
        }
        case 'custom-first': {
          this.optionsEl.classList.add('hidden');
          this.formEl.classList.remove('hidden');
          this.formEl.classList.add('icon-first');
          this.optionGroups.placement.classList.remove('hidden');
          this.optionGroups.text.classList.remove('hidden');
          this.optionGroups.icons.classList.remove('hidden');
          this.textGroups.toggle.classList.remove('hidden');
          this.textGroups.text.classList.add('hidden');
          this.iconGroups.toggle.classList.add('hidden');
          this.iconGroups.icon.classList.add('hidden');
          this.iconGroups.custom.classList.remove('hidden');
          this.iconGroups.placement.classList.remove('hidden');
          this.updateIconPlacementVisibility();
          break;
        }
        case 'add-line': {
          if (button.disabled) return;
          const hasLogo = this.hasLogo();
          const { remainingAvailableLines } = this.getRemainingAvailableTextLines();
          if (remainingAvailableLines <= 0) { return; }
          const nextLineToShow = this.lines.find(l => l.classList.contains('!hidden'));
          if (!nextLineToShow) { return; }
          nextLineToShow.classList.remove('!hidden');
          nextLineToShow.querySelector('input')?.focus();
          if (
            (!hasLogo && remainingAvailableLines === 1)
          ) {
            this.updateOptionGroupState(`icons`, remainingAvailableLines === 1);
            this.resetAddIconOrCustomLogoToggleState();
          }
          this.updateAddButtons();
          this.updateLineTotal();
          this.updateEmbroideryState();
          break;
        }
        case `enable-text`: {
          const value = button.value;
          this.textGroups.text.classList.toggle(`hidden`, value === `none`);
          this.updateIconPlacementVisibility();
          if (value === `none`) {
            this.resetTextState();
            this.updateGhost();
          }
          break;
        }
        case `enable-icons`: {
          const value = button.value;
          this.iconGroups.icon.classList.toggle(`hidden`, value !== `icon`);
          this.iconGroups.custom.classList.toggle(`hidden`, value !== `custom`);
          this.updateIconPlacementVisibility();
          if (
            (value === `icon` && this.logo.type !== `preset_logo`) ||
            (value === `custom` && !['custom_logo', 'customer_logo'].includes(this.logo.type)) ||
            value === `none`
          ) {
            this.resetIconState();
            this.resetCustomLogoState();
            this.updateGhost();
          }
          this.updateAddButtons();
          this.updateEmbroideryState();
          break;
        }
        case 'remove-line': {
          const line = button.closest('[data-text-line]');
          if (!line) { return; }
          const input = line.querySelector('input');
          if (input) { input.value = ''; }
          line.classList.add('!hidden');
          const {remainingAvailableLines} = this.getRemainingAvailableTextLines();
          this.updateOptionGroupState(`icons`, remainingAvailableLines === 0);
          this.updateAddButtons();
          this.updateLineTotal();
          this.updateEmbroideryState();
          break;
        }
        case 'choose-position': {
          if (!button.checked) return;
          this.positionEl.textContent = button.dataset.value.toLowerCase();
          this.position = {
            handle: button.dataset.handle,
            value: button.dataset.value,
            horizontal: button.dataset.horizontal,
            vertical: button.dataset.vertical,
            rotation: button.dataset.rotation || 0
          };
          this.updateGhost();
          break;
        }
        case 'change-font': {
          this.querySelectorAll('[data-action="change-font"]').forEach(b => b.classList.remove('active'));
          button.classList.add('active');
          this.fontNameEl.textContent = button.dataset.fontName;
          this.font = {
            name: button.dataset.fontName,
            family: button.dataset.fontFamily,
            material: button.dataset.fontMaterial,
            size: button.dataset.fontSize
          };
          this.updateInputFonts();
          this.updateGhost();
          break;
        }
        case 'change-color': {
          this.querySelectorAll('[data-action="change-color"]').forEach(b => b.classList.remove('active'));
          button.classList.add('active');
          this.colorNameEl.textContent = button.dataset.colorName;
          this.color = {
            name: button.dataset.colorName,
            material: button.dataset.colorMaterial,
            value: button.querySelector('div')?.style.backgroundColor || ''
          };
          this.updateGhost();
          break;
        }
        case 'open-account-drawer': {
          document.querySelector('drawer-modal')?.close();
          const accountUrl = document.querySelector('account-drawer')?.dataset?.accountUrl;
          if (accountUrl) {
            setTimeout(() => document.querySelector(`[href="${accountUrl}"]`)?.click(), 520);
          }
          break;
        }
        case 'add-logo': {
          this.querySelectorAll('[data-action="add-logo"],[data-action="remove-logo"]').forEach(b => b.classList.remove('active'));
          button.classList.add('active');
          const price = Number(button.dataset.logoPrice || 0);
          const name = button.dataset.logoName || '';
          if (this.logoPriceEl.length) {
            this.logoPriceEl.forEach(el => {
              el.textContent = price ? `(+${this.formatMoney(price)}):` : '';
            });
          }
          if (this.logoNameEl.length) {
            this.logoNameEl.forEach(el => {
              el.textContent = name.toLowerCase();
            });
          }
          this.currentCustomEl.textContent = '';
          this.customLogoPreview?.classList.add('hidden');
          this.customLogoEmpty?.classList.remove('hidden');
          if (this.customLogoInput) this.customLogoInput.value = '';
          this.logo = {
            id: button.dataset.logoId,
            name,
            type: button.dataset.logoCustomer ? `customer_logo` : `preset_logo`,
            materialId: button.dataset.logoMaterialId,
            price,
            url: button.dataset.logoUrl
          };
          this.updateNotesVisibility();
          this.updateLogoConstraints();
          this.updateAddButtons();
          this.updateLineTotal();
          this.updateEmbroideryState();
          this.updateGhost();
          break;
        }
        case 'remove-logo': {
          this.querySelectorAll('[data-action="add-logo"],[data-action="remove-logo"]').forEach(b => b.classList.remove('active'));
          button.classList.add('active');
          if (this.logoPriceEl.length) this.logoPriceEl.forEach(el => el.textContent = '');
          if (this.logoNameEl.length) this.logoNameEl.forEach(el => el.textContent = '');
          this.logo = {
            id: null,
            name: null,
            type: null,
            materialId: null,
            price: 0,
            url: null,
          };
          this.updateLogoConstraints();
          this.updateAddButtons();
          this.updateLineTotal();
          this.updateEmbroideryState();
          this.updateGhost();
          break;
        }
        case 'choose-logo-position': {
          this.querySelectorAll('[data-action="choose-logo-position"]').forEach(b => b.classList.remove('active'));
          button.classList.add('active');
          this.logoPosition = { value: button.dataset.value };
          this.logoPositionEl.textContent = button.dataset.value === 'Above' ? 'Above Text' : 'Below Text';
          this.updateGhost();
          break;
        }
        case 'trigger-custom-logo': {
          this.customLogoInput?.click();
          break;
        }
        case 'remove-custom-logo': {
          this.logo = {
            id: null,
            name: null,
            type: null,
            materialId: null,
            price: 0,
            url: null,
          };
          if (this.customLogoInput) this.customLogoInput.value = '';
          if (this.customLogoNotes) this.customLogoNotes.value = '';
          this.customLogoPreview?.classList.add('hidden');
          this.customLogoEmpty?.classList.remove('hidden');
          this.currentCustomEl.textContent = '';
          this.updateNotesVisibility();
          this.updateLogoConstraints();
          this.updateAddButtons();
          this.updateEmbroideryState();
          this.updateGhost();
          break;
        }
        case 'clear-settings': {
          this.resetState();
          this.atcStatus(false);
          break;
        }
        case 'add-embroidery': {
          if (['custom_logo', 'customer_logo'].includes(this.logo?.type) && !this.customLogoAuthCheckbox?.checked) {
            e.stopPropagation();
            this.customLogoAuthError?.classList.remove('hidden');
            return;
          }
          this.customLogoAuthError?.classList.add('hidden');
          this.atcStatus(true);
          break;
        }
      }
    }

    updateAddButtons() {
      const textCount = this.lines.filter(l => !l.classList.contains('!hidden')).length;
      const logoCount = this.hasLogo() ? 1 : 0;
      const totalCount = textCount + logoCount;
      const maxReached = totalCount >= this.maxLines;
      const hasHidden = this.lines.some(l => l.classList.contains('!hidden'));
      const disable = maxReached || !hasHidden;
      this.lines.forEach(line => line.querySelector('[data-action="add-line"]')?.toggleAttribute('disabled', disable));
    }
    updateOptionGroupState(groupKey, state) {
      const group = this.optionGroups[groupKey];
      group.querySelector(`[data-icon-group="toggle"]`).querySelectorAll('input').forEach(input => {
        if (input.value !== `none`) {
          input.disabled = state;
        }
      });
      this.querySelector(`[data-max-lines-error]`).classList.toggle('hidden', !state);
    }

    updateLineTotal() {
      const visibleCount = this.lines.filter(l => !l.classList.contains('!hidden')).length;
      const linePrices = new Array(visibleCount).fill(0);
      let totalLinePrice = 0;
      linePrices.forEach((_, i) => {
        const price = this.getAttribute(`data-line-${i + 1}-price`);
        totalLinePrice += Number(price);
      });
      this.totalEl.textContent = this.formatMoney(totalLinePrice);
      const countTotalEl = this.querySelector('[data-line-count-total]');
      const countCopyEl = this.querySelector('[data-line-count-copy]');
      if (countTotalEl) countTotalEl.textContent = visibleCount;
      if (countCopyEl) countCopyEl.textContent = visibleCount === 1 ? 'Line' : 'Lines';
    }


    updateEmbroideryState() {
      const filledLines = this.lines.filter(line => !line.classList.contains('!hidden') &&  line.querySelector('input')?.value.trim()).length;
      const hasCustomLogo = this.logo?.type === 'custom_logo';
      const customLogoMode = this.iconGroups?.custom && !this.iconGroups.custom.classList.contains('hidden');
      const active = (filledLines > 0 || this.hasLogo()) && (!customLogoMode || this.hasLogo());
      if (this.ctaButton) this.ctaButton.disabled = !active;
      if (!active) {
        this.embroideryTotalEl.textContent = '';
        this.updateGhost();
        return;
      }
      const logoTotal = (this.logo?.price || 0) + (hasCustomLogo ? this.customLogoDigitizationPrice : 0);
      let totalLinePrice = 0;
      const linePrices = new Array(filledLines).fill(0);
      linePrices.forEach((_, i) => {
        const price = this.getAttribute(`data-line-${i + 1}-price`);
        totalLinePrice += Number(price);
      });
      const total = totalLinePrice + logoTotal;
      this.embroideryTotalEl.textContent = `+${this.formatMoney(total)}`;
      this.updateGhost();
    }

    updateIconPlacementVisibility() {
      const textVisible = !this.textGroups.text.classList.contains('hidden');
      const iconVisible = !this.iconGroups.icon.classList.contains('hidden');
      const customVisible = !this.iconGroups.custom.classList.contains('hidden');
      this.iconGroups.placement.classList.toggle(
        'hidden',
        !(textVisible && (iconVisible || customVisible))
      );
    }


    updateLogoConstraints() {
      const hasLogo = this.hasLogo();
      this.logoPositionGroup?.classList.toggle('hidden', !hasLogo);
      const maxTextLines = this.maxLines - (hasLogo ? 1 : 0);
      if (maxTextLines < 0) return;
      const visibleLines = this.lines.filter(l => !l.classList.contains('!hidden'));
      visibleLines.slice(maxTextLines).forEach(line => {
        line.querySelector('input').value = '';
        line.classList.add('!hidden');
      });
    }

    async handleCustomLogoFile(file) {
      const allowed = ['image/png','image/jpeg','image/svg+xml'];
      if (!allowed.includes(file.type)) {
        if (this.customLogoInput) this.customLogoInput.value = '';
        this.showCustomLogoError('Please upload a PNG, JPG, or SVG file.');
        return;
      }
      this.clearCustomLogoError();
      this.setCustomLogoLoading(true);
      try {
        const formData = new FormData();
        formData.append('file', file);

        const res = await fetch('https://winem.sparkyapps.dev/api/upload', {
          method: 'POST',
          body: formData
        });
        if (!res.ok) {throw new Error('upload_failed');}
        const data = await res.json();
        if (!data?.url) {throw new Error('invalid_response');}
        this.setCustomLogo(data.url, file.name);
      } catch {
        if (this.customLogoInput) this.customLogoInput.value = '';
        this.showCustomLogoError('Upload failed. Please try again.');
      } finally {
        this.setCustomLogoLoading(false);
      }
    }

    setCustomLogoLoading(loading) {
      this.customLogoUploader?.classList.toggle('loading', loading);
      this.customLogoLoader?.classList.toggle('hidden', !loading);
      if (this.customLogoInput) this.customLogoInput.disabled = loading;
    }

    setCustomLogo(url, name) {
      this.querySelectorAll('[data-action="add-logo"],[data-action="remove-logo"]').forEach(b => b.classList.remove('active'));
      this.querySelector('[data-action="remove-logo"]')?.classList.add('active');
      this.logoNameEl.textContent = '';
      this.logo = {
        id: crypto.randomUUID(),
        name,
        type: `custom_logo`,
        materialId: this.customLogoMaterialId,
        price: this.customLogoPrice,
        url,
      };
      this.currentCustomEl.textContent = `(+$${this.customLogoPrice} & $${this.customLogoDigitizationPrice} digitization fee)`;
      this.customLogoImage.src = url;
      this.customLogoImage.alt = name || '';
      this.customLogoEmpty.classList.add('hidden');
      this.customLogoPreview.classList.remove('hidden');
      this.updateNotesVisibility();
      this.updateLogoConstraints();
      this.updateAddButtons();
      this.updateEmbroideryState();
      this.updateGhost();
    }

    showCustomLogoError(message) {
      if (!this.customLogoError) return;
      this.customLogoError.textContent = message;
      this.customLogoError.classList.remove('hidden');
      this.customLogoUploader?.classList.add('error');
    }

    clearCustomLogoError() {
      if (!this.customLogoError) return;
      this.customLogoError.classList.add('hidden');
      this.customLogoUploader?.classList.remove('error');
    }

    updateInputFonts() {
      this.lines.forEach(line => {
        const input = line.querySelector('input');
        if (!input) return;
        input.style.fontFamily = this.font?.family || '';
        input.style.fontSize = this.font?.size || '';
        input.style.fontWeight = '600';
        input.style.setProperty('--embroidery-font-family', this.font?.family || '');
        input.style.setProperty('--embroidery-font-size', this.font?.size || '');
      });
    }

    updateGhost() {
      if (!this.ghostCopy) return;
      this.ghostCopy.innerHTML = '';
      const lines = this.lines
        .filter(line => !line.classList.contains('!hidden'))
        .map(line => line.querySelector('input')?.value.trim())
        .filter(Boolean);
      if (!lines.length && !this.hasLogo()) {
        this.ghostCopy.classList.add('hidden');
        return;
      }
      this.ghostCopy.classList.remove('hidden');
      const container = document.createElement('div');
      if (this.hasLogo() && this.logo?.url && this.logoPosition.value === 'Above') {
        container.appendChild(this.buildGhostLogo());
      }
      lines.forEach(text => {
        const span = document.createElement('span');
        span.textContent = text;
        span.style.fontFamily = this.font?.family || 'inherit';
        span.style.fontSize = this.font?.size || 'inherit';
        span.style.color = this.color?.value || 'inherit';
        container.appendChild(span);
      });
      if (this.hasLogo() && this.logo?.url && this.logoPosition.value === 'Below') {
        container.appendChild(this.buildGhostLogo());
      }
      this.ghostCopy.appendChild(container);
      this.updateGhostPosition();
    }

    buildGhostLogo() {
      const img = document.createElement('img');
      img.src = this.logo.url;
      img.alt = this.logo.name || '';
      img.style.objectFit = 'contain';
      return img;
    }

    updateGhostPosition() {
      const active = this.querySelector('[data-action="choose-position"]:checked');
      if (!active) return;
      const rotation = active.dataset.rotation || 0;
      this.ghostCopy.style.left = `${active.dataset.horizontal}%`;
      this.ghostCopy.style.top = `${active.dataset.vertical}%`;
      this.ghostCopy.style.transform = `translate(-50%, -50%) rotate(${rotation}deg)`;
      if (this.previewView === 'zoom') this.applyZoom(active);
    }

    updatePreviewView(view) {
      this.previewView = view;
      this.previewTabs?.querySelectorAll('[data-preview-tab]').forEach(btn => {
        const isActive = btn.dataset.previewTab === view;
        btn.classList.toggle('bg-primaryLight', isActive);
        btn.classList.toggle('border-2', isActive);
        btn.classList.toggle('border-tertiaryLight', isActive);
      });
      const showSleeve = view === 'sleeve' && this.sleeveImageEl;
      this.fullImageEl?.classList.toggle('hidden', !!showSleeve);
      this.sleeveImageEl?.classList.toggle('hidden', !showSleeve);
      this.ghostCopy?.classList.toggle('!hidden', !!showSleeve);
      if (view === 'zoom') {
        const active = this.querySelector('[data-action="choose-position"]:checked');
        if (active) this.applyZoom(active);
      } else {
        if (this.ghostImageInner) {
          this.ghostImageInner.style.transformOrigin = '';
          this.ghostImageInner.style.transform = '';
        }
      }
    }

    applyZoom(positionEl) {
      if (!this.ghostImageInner) return;
      const h = Number(positionEl.dataset.horizontal);
      const v = Number(positionEl.dataset.vertical);
      this.ghostImageInner.style.transformOrigin = `${h}% ${v}%`;
      this.ghostImageInner.style.transform = 'scale(2.5)';
    }

    resetState() {
      this.optionsEl.classList.remove('hidden');
      this.formEl.classList.add('hidden');
      this.formEl.classList.remove('icon-first');
      Object.values(this.optionGroups).forEach(el => el?.classList.add('hidden'));
      Object.values(this.textGroups).forEach(el => el?.classList.add('hidden'));
      Object.values(this.iconGroups).forEach(el => el?.classList.add('hidden'));
      this.resetTextState();
      this.resetIconState();
      this.resetCustomLogoState();
      const noneButton = this.querySelector('[data-action="remove-logo"]');
      noneButton?.classList.add('active');
      this.externalATC.classList.remove('has-embroidery');
      const presetLogoPosition = this.querySelector('[data-action="choose-logo-position"]');
      if (presetLogoPosition) {
        this.querySelectorAll('[data-action="choose-logo-position"]').forEach(b => b.classList.remove('active'));
        presetLogoPosition.classList.add('active');
        this.logoPosition = { value: presetLogoPosition.dataset.value };
        this.logoPositionEl.textContent = presetLogoPosition.dataset.value;
      }
      
      this.updateOptionGroupState(`icons`, false);
      this.resetAddIconOrCustomLogoToggleState();
      this.resetAddTextToggleState();
      this.updateLogoConstraints();
      this.updateAddButtons();
      this.updateLineTotal();
      this.updateEmbroideryState();
      this.updateGhost();
    }
    resetTextState() {
      this.lines.forEach((line, index) => {
        const input = line.querySelector('input');
        if (input) input.value = '';
        line.classList.toggle('!hidden', index !== 0);
      });
      const defaultPosition = this.querySelector('[data-action="choose-position"]');
      if (defaultPosition) {
        defaultPosition.checked = true;
        this.position = {
          handle: defaultPosition.dataset.handle,
          value: defaultPosition.dataset.value,
          horizontal: defaultPosition.dataset.horizontal,
          vertical: defaultPosition.dataset.vertical
        };
        this.positionEl.textContent = defaultPosition.dataset.value.toLowerCase();
      }
      const defaultFont = this.querySelector('[data-action="change-font"]');
      if (defaultFont) {
        this.querySelectorAll('[data-action="change-font"]').forEach(b => b.classList.remove('active'));
        defaultFont.classList.add('active');
        this.font = {
          name: defaultFont.dataset.fontName,
          family: defaultFont.dataset.fontFamily,
          material: defaultFont.dataset.fontMaterial,
          size: defaultFont.dataset.fontSize
        };
        this.fontNameEl.textContent = defaultFont.dataset.fontName;
        this.updateInputFonts();
      }
      const defaultColor = this.querySelector('[data-action="change-color"]');
      if (defaultColor) {
        this.querySelectorAll('[data-action="change-color"]').forEach(b => b.classList.remove('active'));
        defaultColor.classList.add('active');
        this.color = {
          name: defaultColor.dataset.colorName,
          material: defaultColor.dataset.colorMaterial,
          value: defaultColor.querySelector('div')?.style.backgroundColor || ''
        };
        this.colorNameEl.textContent = defaultColor.dataset.colorName;
      }
    }
    resetIconState() {
      this.logo = {
        id: null,
        name: null,
        type: null,
        materialId: null,
        price: 0,
        url: null,
      };
      if (this.logoPriceEl.length) this.logoPriceEl.forEach(el => el.textContent = '');
      if (this.logoNameEl.length) this.logoNameEl.forEach(el => el.textContent = '');
      this.querySelectorAll('[data-action="add-logo"],[data-action="remove-logo"]').forEach(b => b.classList.remove('active'));
    }
    resetCustomLogoState() {
      this.logo = {
        id: null,
        name: null,
        type: null,
        materialId: null,
        price: 0,
        url: null,
      };
      if (this.customLogoInput) this.customLogoInput.value = '';
      this.customLogoPreview?.classList.add('hidden');
      this.customLogoEmpty?.classList.remove('hidden');
      this.currentCustomEl.textContent = '';
      if (this.customLogoNotes) this.customLogoNotes.value = '';
      if (this.customLogoAuthCheckbox) this.customLogoAuthCheckbox.checked = false;
      this.customLogoAuthError?.classList.add('hidden');
      this.updateNotesVisibility();
    }
    updateNotesVisibility() {
      const show = this.logo?.type === 'custom_logo';
      this.customLogoNotesContainer?.classList.toggle('hidden', !show);
    }
    resetAddIconOrCustomLogoToggleState() {
      const iconGroupToggles = this.querySelectorAll('[name="icon-group-toggle"]')
      iconGroupToggles.forEach((radio, index) => radio.checked = index === 0);
      this.iconGroups.icon.classList.toggle('hidden', true);
      this.updateIconPlacementVisibility();
    }
    resetAddTextToggleState() {
      const textGroupToggles = this.querySelectorAll('[name="text-toggle"]')
      textGroupToggles.forEach((radio, index) => radio.checked = index === 0);
    }

    atcStatus(required) {
      if (!this.externalATC || !this.confirmEmbroideryEl) return;
      if (required) {
        this.confirmEmbroideryEl.classList.remove('hidden');
        this.externalATC.classList.add('emb-disabled');
        this.externalQTY?.classList.add('hidden');
        this.addSpan.textContent = 'View Embroidery';
        if (this.confirmCheckbox) {
          this.confirmCheckbox.checked = false;
        }
      } else {
        this.confirmEmbroideryEl.classList.add('hidden');
        this.externalATC.classList.remove('emb-disabled');
        this.externalQTY?.classList.remove('hidden');
        this.addSpan.textContent = 'Add Embroidery';
        if (this.confirmCheckbox) {
          this.confirmCheckbox.checked = false;
        }
      }
    }
  }

  customElements.define('embroidery-modal', Embroidery);
}
